<template>
	<div class="btn_wrapper">
		<slot></slot>
	</div>
</template>

<script>
	export default {};
</script>

<style></style>
